<template>
  <span class="hidden truncate @[12rem]/navigation:inline-block">
    <slot />
  </span>
</template>
